import { useEffect, useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";

const LINKS = [
  { href: "/#how", label: "Your journey" },
  { href: "/#passport", label: "Skin Passport" },
  { href: "/standards", label: "Safety & Care" },
  { href: "/membership", label: "Membership" },
  { href: "/blog", label: "Blog" },
  { href: "/book", label: "Book a session" },
];

const Logo = ({ className = "" }) => (
  <a href="/#top" className={`font-disp font-extrabold text-2xl tracking-[-0.04em] text-ink ${className}`} data-testid="nav-logo">
    <span className="text-coralDeep">sae</span>bit
  </a>
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 backdrop-blur-xl ${
        scrolled ? "bg-cream/85 border-b border-ink/10 py-3" : "bg-cream/40 py-4"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[0.95rem] font-medium text-mutedink hover:text-coral transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/quiz"
            className="group inline-flex items-center gap-2 bg-clay text-white font-semibold text-sm whitespace-nowrap px-5 py-2.5 rounded-full border-2 border-ink shadow-[3px_3px_0_#3D2B24] hover:-translate-x-[1px] hover:-translate-y-[1px] hover:shadow-[5px_5px_0_#3D2B24] transition-all"
            data-testid="nav-cta-quiz"
          >
            Skin Assessment
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </nav>

        <button
          className="md:hidden text-ink p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-ink/10 px-5 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-mutedink font-medium">
              {l.label}
            </a>
          ))}
          <a
            href="/quiz"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center gap-2 bg-clay text-white font-semibold px-5 py-3 rounded-full border-2 border-ink shadow-[3px_3px_0_#3D2B24]"
          >
            Skin Assessment <ArrowRight size={16} />
          </a>
        </div>
      )}
    </header>
  );
}
